import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import AutoComplete from 'material-ui/AutoComplete';
import RaisedButton from 'material-ui/RaisedButton';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Popover, { PopoverAnimationVertical } from 'material-ui/Popover';

import styles from 'styles';
import { updateCargoOrder } from 'actions/cargoes/orders';

class AddWordSelection extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            dataSource: [],
            searchText: '',
            type: 'common',
            gazetter: {
                gazetteerName: '',
                gazetteerType: 'common',
                fileName: '',
                gazType: 'common',
                value: props.selectedText,
            },
        };

        this.onUpdateInput = this.onUpdateInput.bind(this);
        this.onNewRequest = this.onNewRequest.bind(this);

        this.handleChangeType = this.handleChangeType.bind(this);
    }

    handleChangeType(event, index, value) {
        this.setState({
            type: value,
            gazetter: {
                ...this.state.gazetter,
                gazType: value,
                gazetteerType: value,
            },
        });
    }

    onUpdateInput(searchText) {
        const dataSource = this.props.listGazetters.filteredList.filter(item => item.fileName.toLowerCase().includes(searchText.toLowerCase()));

        this.setState({
            searchText,
            dataSource: dataSource.map(item => ({
                name: item.fileName,
                item,
            })),
        });
    }

    onNewRequest(updateProperties) {
        if (!updateProperties) {
            return;
        }

        this.setState({
            searchText: updateProperties.name,
            dataSource: [],
            type: updateProperties.item.$target,
            gazetter: {
                ...this.state.gazetter,
                gazetteerName: updateProperties.name,
                fileName: updateProperties.name,
                gazType: updateProperties.item.$target,
                gazetteerType: updateProperties.item.$target,
            },
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            gazetter: {
                ...this.state.gazetter,
                value: nextProps.selectedText,
            },
        });
    }

    render() {
        const {
            dataSource, searchText, type, gazetter, 
        } = this.state;
        const {
            openAddWordSelection, elementTarget, closePopover, selectedText, addNewGazetter, 
        } = this.props;

        return (
            <div className='popup'>
                <Popover
                    open={openAddWordSelection}
                    anchorEl={elementTarget}
                    onRequestClose={closePopover}
                    animation={PopoverAnimationVertical}
                    anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
                    targetOrigin={{ horizontal: 'left', vertical: 'top' }}
                >
                    <div className='popup-choose'>
                        <div className='chosen'>
                            <div className='chosen-title'>
                               Add word to gazetter
                            </div>
                            <div className='chosen-row'>
                                {`'${selectedText}'`}
                            </div>

                            <div style={{ margin: '10px 0' }}>
                                <AutoComplete
                                    textFieldStyle={styles.autoCompleteCSS}
                                    floatingLabelText='Choose gazetter'
                                    searchText={searchText}
                                    dataSource={dataSource}
                                    dataSourceConfig={{ text: 'name', value: 'item' }}
                                    onUpdateInput={this.onUpdateInput}
                                    onNewRequest={this.onNewRequest}
                                    filter={AutoComplete.noFilter}
                                    listStyle={styles.autoCompleteListStyle}
                                    popoverProps={{
                                        canAutoPosition: true,
                                        anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
                                        targetOrigin: { horizontal: 'left', vertical: 'top' },
                                    }}
                                />
                            </div>

                            <div style={{ margin: '10px 0' }}>
                                <SelectField
                                    floatingLabelText='Group'
                                    value={type}
                                    onChange={this.handleChangeType}
                                >
                                    <MenuItem value='common' primaryText='common' />
                                    <MenuItem value='cargo' primaryText='cargo' />
                                    <MenuItem value='vessel' primaryText='vessel' />
                                </SelectField>
                            </div>

                            <div style={{ margin: '10px 0', textAlign: 'center' }}>
                                <RaisedButton
                                    onClick={() => {
                                        closePopover();
                                        addNewGazetter(gazetter);
                                    }}
                                    primary
                                    label='Add word'
                                />
                            </div>
                        </div>
                    </div>
                </Popover>
            </div>
        );
    }
}

export default connect(
    (state, ownProps) => ({
        ...ownProps,
        listGazetters: state.listGazetters,
    }),
    dispatch => bindActionCreators({
        updateCargoOrder,
    }, dispatch),
)(AddWordSelection);



// WEBPACK FOOTER //
// ./app/components/Letters/Single/Gazetter/Content/AddWordSelection.jsx